function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { if (r) i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n;else { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } o("next", 0), o("throw", 1), o("return", 2); } }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
import { decode as base64url } from '../../runtime/base64url.js';
import verify from '../../runtime/verify.js';
import { JOSEAlgNotAllowed, JWSInvalid, JWSSignatureVerificationFailed } from '../../util/errors.js';
import { concat, encoder, decoder } from '../../lib/buffer_utils.js';
import isDisjoint from '../../lib/is_disjoint.js';
import isObject from '../../lib/is_object.js';
import { checkKeyTypeWithJwk } from '../../lib/check_key_type.js';
import validateCrit from '../../lib/validate_crit.js';
import validateAlgorithms from '../../lib/validate_algorithms.js';
import { isJWK } from '../../lib/is_jwk.js';
import { importJWK } from '../../key/import.js';
export function flattenedVerify(_x, _x2, _x3) {
  return _flattenedVerify.apply(this, arguments);
}
function _flattenedVerify() {
  _flattenedVerify = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(jws, key, options) {
    var _jws$protected;
    var parsedProt, protectedHeader, joseHeader, extensions, b64, alg, algorithms, resolvedKey, data, signature, verified, payload, result, _t, _t2, _t3;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          if (isObject(jws)) {
            _context.n = 1;
            break;
          }
          throw new JWSInvalid('Flattened JWS must be an object');
        case 1:
          if (!(jws.protected === undefined && jws.header === undefined)) {
            _context.n = 2;
            break;
          }
          throw new JWSInvalid('Flattened JWS must have either of the "protected" or "header" members');
        case 2:
          if (!(jws.protected !== undefined && typeof jws.protected !== 'string')) {
            _context.n = 3;
            break;
          }
          throw new JWSInvalid('JWS Protected Header incorrect type');
        case 3:
          if (!(jws.payload === undefined)) {
            _context.n = 4;
            break;
          }
          throw new JWSInvalid('JWS Payload missing');
        case 4:
          if (!(typeof jws.signature !== 'string')) {
            _context.n = 5;
            break;
          }
          throw new JWSInvalid('JWS Signature missing or incorrect type');
        case 5:
          if (!(jws.header !== undefined && !isObject(jws.header))) {
            _context.n = 6;
            break;
          }
          throw new JWSInvalid('JWS Unprotected Header incorrect type');
        case 6:
          parsedProt = {};
          if (!jws.protected) {
            _context.n = 9;
            break;
          }
          _context.p = 7;
          protectedHeader = base64url(jws.protected);
          parsedProt = JSON.parse(decoder.decode(protectedHeader));
          _context.n = 9;
          break;
        case 8:
          _context.p = 8;
          _t = _context.v;
          throw new JWSInvalid('JWS Protected Header is invalid');
        case 9:
          if (isDisjoint(parsedProt, jws.header)) {
            _context.n = 10;
            break;
          }
          throw new JWSInvalid('JWS Protected and JWS Unprotected Header Parameter names must be disjoint');
        case 10:
          joseHeader = _objectSpread(_objectSpread({}, parsedProt), jws.header);
          extensions = validateCrit(JWSInvalid, new Map([['b64', true]]), options === null || options === void 0 ? void 0 : options.crit, parsedProt, joseHeader);
          b64 = true;
          if (!extensions.has('b64')) {
            _context.n = 11;
            break;
          }
          b64 = parsedProt.b64;
          if (!(typeof b64 !== 'boolean')) {
            _context.n = 11;
            break;
          }
          throw new JWSInvalid('The "b64" (base64url-encode payload) Header Parameter must be a boolean');
        case 11:
          alg = joseHeader.alg;
          if (!(typeof alg !== 'string' || !alg)) {
            _context.n = 12;
            break;
          }
          throw new JWSInvalid('JWS "alg" (Algorithm) Header Parameter missing or invalid');
        case 12:
          algorithms = options && validateAlgorithms('algorithms', options.algorithms);
          if (!(algorithms && !algorithms.has(alg))) {
            _context.n = 13;
            break;
          }
          throw new JOSEAlgNotAllowed('"alg" (Algorithm) Header Parameter value not allowed');
        case 13:
          if (!b64) {
            _context.n = 15;
            break;
          }
          if (!(typeof jws.payload !== 'string')) {
            _context.n = 14;
            break;
          }
          throw new JWSInvalid('JWS Payload must be a string');
        case 14:
          _context.n = 16;
          break;
        case 15:
          if (!(typeof jws.payload !== 'string' && !(jws.payload instanceof Uint8Array))) {
            _context.n = 16;
            break;
          }
          throw new JWSInvalid('JWS Payload must be a string or an Uint8Array instance');
        case 16:
          resolvedKey = false;
          if (!(typeof key === 'function')) {
            _context.n = 20;
            break;
          }
          _context.n = 17;
          return key(parsedProt, jws);
        case 17:
          key = _context.v;
          resolvedKey = true;
          checkKeyTypeWithJwk(alg, key, 'verify');
          if (!isJWK(key)) {
            _context.n = 19;
            break;
          }
          _context.n = 18;
          return importJWK(key, alg);
        case 18:
          key = _context.v;
        case 19:
          _context.n = 21;
          break;
        case 20:
          checkKeyTypeWithJwk(alg, key, 'verify');
        case 21:
          data = concat(encoder.encode((_jws$protected = jws.protected) !== null && _jws$protected !== void 0 ? _jws$protected : ''), encoder.encode('.'), typeof jws.payload === 'string' ? encoder.encode(jws.payload) : jws.payload);
          _context.p = 22;
          signature = base64url(jws.signature);
          _context.n = 24;
          break;
        case 23:
          _context.p = 23;
          _t2 = _context.v;
          throw new JWSInvalid('Failed to base64url decode the signature');
        case 24:
          _context.n = 25;
          return verify(alg, key, signature, data);
        case 25:
          verified = _context.v;
          if (verified) {
            _context.n = 26;
            break;
          }
          throw new JWSSignatureVerificationFailed();
        case 26:
          if (!b64) {
            _context.n = 30;
            break;
          }
          _context.p = 27;
          payload = base64url(jws.payload);
          _context.n = 29;
          break;
        case 28:
          _context.p = 28;
          _t3 = _context.v;
          throw new JWSInvalid('Failed to base64url decode the payload');
        case 29:
          _context.n = 31;
          break;
        case 30:
          if (typeof jws.payload === 'string') {
            payload = encoder.encode(jws.payload);
          } else {
            payload = jws.payload;
          }
        case 31:
          result = {
            payload: payload
          };
          if (jws.protected !== undefined) {
            result.protectedHeader = parsedProt;
          }
          if (jws.header !== undefined) {
            result.unprotectedHeader = jws.header;
          }
          if (!resolvedKey) {
            _context.n = 32;
            break;
          }
          return _context.a(2, _objectSpread(_objectSpread({}, result), {}, {
            key: key
          }));
        case 32:
          return _context.a(2, result);
      }
    }, _callee, null, [[27, 28], [22, 23], [7, 8]]);
  }));
  return _flattenedVerify.apply(this, arguments);
}